import { render, staticRenderFns } from "./CrosslinkTeaser.vue?vue&type=template&id=3fb34a22&"
import script from "./CrosslinkTeaser.vue?vue&type=script&lang=js&"
export * from "./CrosslinkTeaser.vue?vue&type=script&lang=js&"
import style0 from "./CrosslinkTeaser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CrosslinkTeaser.vue"
export default component.exports